<template>
    <div class="transfer">
        <b-row>
            <b-col cols-="12" md="4">
                <b-form-group id="from" label="Partenza" label-for="from">
                    <b-form-input
                        size="sm"
                        id="from"
                        v-model="from"
                        placeholder="Roma, Milano, ..."
                        @input="updated"
                    ></b-form-input>
                </b-form-group>
            </b-col>
            <b-col cols-="12" md="4">
                <b-form-group id="to" label="Arrivo" label-for="to">
                    <b-form-input
                        size="sm"
                        id="to"
                        v-model="to"
                        placeholder="Ancona, Bologna, ..."
                        @input="updated"
                    ></b-form-input>
                </b-form-group>
            </b-col>
            <b-col cols-="12" md="4">
                <b-form-group id="date_time" label="Data e ora" label-for="date_time">
                    <b-input-group>
                        <b-form-input
                            size="sm"
                            id="date_time"
                            v-model="date_time_friendly"
                            placeholder="Orario"
                            disabled
                        ></b-form-input>
                        <b-input-group-append>
                        <b-button variant="secondary" v-b-toggle="'service_'+service_index+'transfer_'+transfer_index"><font-awesome-icon icon="pencil-alt" /></b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>                                
                <b-collapse :id="'service_'+service_index+'transfer_'+transfer_index">
                    <div class="date--pickers">
                        <!-- date: 2021-11-01 -->
                        <!-- time: 21:00:00 -->
                        <date-time-picker
                            :header="false"
                            :smart_inputs="true"
                            :day="transfer.date"
                            :hour="transfer.time"
                            :context="{
                                transfer_index: transfer_index
                            }"
                            @updated="(value) => refresh_date({
                                day: value.day,
                                hour: value.hour,
                                context: value.context
                            })"
                        />
                    </div>
                </b-collapse>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import DateTimePicker from '@/components/blocks/date-time-picker'
    export default {
        name: 'transfer',
        components: {
            'date-time-picker': DateTimePicker,
        },
        props: {
            transfer: {
                type: Object,
                default: () => {}
            },
            transfer_index: Number,
            service_index: Number,
        },
        data() {
            return {     
                from: this.transfer.from,
                to: this.transfer.to,
                date_time_friendly: this.transfer.date_time_friendly,
            }
        },
        methods:
        {
            updated()
            {
                let payload = {
                    ...this.transfer,
                    transfer_index: this.transfer_index,
                    transfer: {
                        from: this.from,
                        to: this.to,
                        date_time_friendly: this.date_time_friendly,
                    }
                }
                this.$emit('updated', payload)
            },
            removed()
            {
                let payload = {
                    transfer_index: this.transfer_index,
                }
                this.$emit('removed', payload)
            },
            refresh_date(payload)
            {
                this.date_time_friendly = payload.day + ' - ' + payload.hour
                this.updated()
            }
        }
    }
</script>

<style lang="scss">
    .transfer
    {
        .service--icon
        {
            height:100%;
            display: flex;
            align-items: flex-end;
            justify-content: center;
            padding:$grid-gutter-width/2 0;
        }
    }
</style>